

























































































import { Component, Vue, Prop } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import SolicitacaoCirurgiaStore from '@/components/SolicitacaoCirurgia/store/SolicitacaoCirurgiaStore'
import { Convenio } from '@/types/_'
import { timeout } from '@/utils/common'
import EventBus from '@/plugins/EventBus'
import moment from 'moment-timezone'

import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'
import ptBrLocale from '@fullcalendar/core/locales/pt-br'

@Component({ components: { FullCalendar } })

export default class ComponentModalDataCirurgia extends Vue {
  @Prop({ required: false }) template: any
  $refs!: {
    calendar: any,
    data: any,
    hora: any,
  }

  loadClose: boolean = false
  loadSchedule: boolean = false
  loadDatesSet: boolean = false

  get getSolicitacaoCirurgiaStore() {
    return getModule(SolicitacaoCirurgiaStore, this.$store)
  }

  get gradeMedicaEventos() {
    return this.getSolicitacaoCirurgiaStore.gradeMedicaEventos
  }

  get dataCirurgia() {
    return this.getSolicitacaoCirurgiaStore.dataCirurgia.dataCirurgia
  }

  set dataCirurgia(value) {
    this.getSolicitacaoCirurgiaStore.setDataCirurgiaDataCirurgia(value)
  }

  get hora() {
    return this.getSolicitacaoCirurgiaStore.dataCirurgia.hora
  }

  set hora(value) {
    this.getSolicitacaoCirurgiaStore.setDataCirurgiaHora(value)
  }

  get opcaoDataPrevisto1() {
    return this.getSolicitacaoCirurgiaStore.solicitacaoCirurgia.opcaoDataPrevisto1
  }

  get convenioDaSolicitacao() {
    const { convenios, solicitacaoCirurgia } = this.getSolicitacaoCirurgiaStore
    let conv = convenios.find((convenio: Convenio) => convenio.id === solicitacaoCirurgia.paciente.convenioId)
    if (!conv) {
      conv = {
        id: '',
        nome: '',
        particular: false,
        status: '',
        convenioUtilizaFluxoDePreviaCirurgica: false,
        prazoEmDiasParaTriagem: 0,
        prazoMaximoEmDiasParaAgendamento: 0,
      }
    }
    return conv
  }

  get configuracoes() {
    return 'prazoEmDiasParaTriagem' in this.convenioDaSolicitacao || 'prazoMaximoEmDiasParaAgendamento' in this.convenioDaSolicitacao
      ? this.convenioDaSolicitacao
      : { prazoEmDiasParaTriagem: 0, prazoMaximoEmDiasParaAgendamento: 0 }
  }

  get prazoParaTriagem() {
    return this.convenioDaSolicitacao && this.convenioDaSolicitacao.prazoMaximoEmDiasParaAgendamento && this.convenioDaSolicitacao.prazoMaximoEmDiasParaAgendamento > 0
      ? moment().add(this.convenioDaSolicitacao.prazoMaximoEmDiasParaAgendamento, 'days').format('YYYY-MM-DD')
      : moment().add(10, 'years').format('YYYY-MM-DD')
  }

  calendarOptions: any = {
    plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin],
    height: 400,
    locale: ptBrLocale,
    timeZone: 'UTC',
    headerToolbar: {
      left: '',
      center: 'title',
      right: 'prev,next',
    },
    initialDate: moment().format('YYYY-MM-DD'),
    initialView: 'timeGridWeek',
    editable: false,
    selectable: false,
    weekends: true,
    allDaySlot: false,
    slotLabelFormat: [
      { hour: 'numeric', minute: 'numeric' },
      { weekday: 'short' },
    ],
    slotMinTime: '08:00:00',
    slotMaxTime: '19:00:00',
    dayHeaderFormat: { weekday: 'short', day: 'numeric', omitCommas: true },
    events: this.gradeMedicaEventos,
    datesSet: this.getGradeDeHorarios,
    validRange: {
      end: this.prazoParaTriagem,
    },
  }

  erroPrazoMaximo: boolean = false
  get errorPrazoMaximo() { return this.erroPrazoMaximo }
  set errorPrazoMaximo(value: boolean) { this.erroPrazoMaximo = value }

  get prazoMaximo() {
    return this.configuracoes.prazoMaximoEmDiasParaAgendamento > 0
      ? [`Selecione uma data até ${moment().add(this.configuracoes.prazoMaximoEmDiasParaAgendamento, 'days').format('DD/MM/YYYY')}.`]
      : []
  }

  diferencaDeDatas(dataSelecionada: Date | string, prazo: number) {
    return Math.floor(moment.duration(moment().add(prazo, 'days').diff(moment(dataSelecionada))).asDays()) >= 0
  }

  async updateCalendar() {
    this.errorPrazoMaximo = false
    if (this.dataCirurgia === 'Invalid date') return
    if (this.configuracoes.prazoMaximoEmDiasParaAgendamento > 0 && !this.diferencaDeDatas(this.dataCirurgia, this.configuracoes.prazoMaximoEmDiasParaAgendamento)) {
      this.errorPrazoMaximo = true
      return
    }

    this.loadingDatesSet = true

    const params: any = {
      inicio: moment(this.dataCirurgia).startOf('week').toISOString(),
      fim: moment(this.dataCirurgia).endOf('week').subtract(1, 'days').toISOString(),
    }

    await this.getSolicitacaoCirurgiaStore.getGradeDeHorarioFromCalendar(params)
    this.$refs.calendar.getApi().setOption('events', [])
    this.$refs.calendar.getApi().addEventSource(this.gradeMedicaEventos)
    this.$refs.calendar.getApi().gotoDate(this.dataCirurgia)
    this.loadingDatesSet = false
  }

  async getGradeDeHorarios({ startStr, endStr }) {
    if (!this.template) return
    this.loadingDatesSet = true
    const params: any = {
      inicio: moment(startStr).toISOString(),
      fim: moment(endStr).subtract(1, 'days').toISOString(),
    }
    await this.getSolicitacaoCirurgiaStore.getGradeDeHorarioFromCalendar(params)
    this.$refs.calendar.getApi().setOption('events', [])
    this.$refs.calendar.getApi().addEventSource(this.gradeMedicaEventos)
    this.loadingDatesSet = false
  }

  get loadingClose() {
    return this.loadClose
  }

  set loadingClose(value: boolean) {
    this.loadClose = value
  }

  get loadingSchedule() {
    return this.loadSchedule
  }

  set loadingSchedule(value: boolean) {
    this.loadSchedule = value
  }

  get loadingDatesSet() {
    return this.loadDatesSet
  }

  set loadingDatesSet(value: boolean) {
    this.loadDatesSet = value
  }

  get showModalDataCirurgia() {
    const { opcaoDataPrevisto1 } = this.getSolicitacaoCirurgiaStore.solicitacaoCirurgia
    if (opcaoDataPrevisto1 !== '' || opcaoDataPrevisto1 !== null) {
      this.getSolicitacaoCirurgiaStore.setDataCirurgiaDataCirurgia(moment(opcaoDataPrevisto1).format('YYYY-MM-DD'))
      this.getSolicitacaoCirurgiaStore.setDataCirurgiaHora(moment(opcaoDataPrevisto1).format('HH:mm'))
    }

    return this.getSolicitacaoCirurgiaStore.modal.dataCirurgia
  }

  set showModalDataCirurgia(value: boolean) {
    this.getSolicitacaoCirurgiaStore.setShowModalDataCirurgia(value)
  }

  closeModalDataCirurgia() {
    this.getSolicitacaoCirurgiaStore.clearGradeMedicaEventos()
    this.getSolicitacaoCirurgiaStore.clearDataCirurgia()
    this.errorPrazoMaximo = false
    this.showModalDataCirurgia = false
  }

  renderFullCalendar() {
    const { calendar }: any = this.$refs
    calendar.getApi().render()
  }

  async agendar() {
    this.loadingSchedule = true

    const { dataCirurgia, hora } = this.getSolicitacaoCirurgiaStore.dataCirurgia
    this.getSolicitacaoCirurgiaStore.setOpcaoDataPrevisto1(moment(`${dataCirurgia}T${hora}`).tz('America/Sao_Paulo').format('YYYY-MM-DDTHH:mm'))

    const response = await this.getSolicitacaoCirurgiaStore.agendarDataCirurgia()

    // @ts-ignore
    if (response.success) {
      EventBus.$emit('setSnackbar', { show: true, text: `Data solicitada com sucesso. ${String.fromCodePoint(0x1F642)}`, icon: 'done', color: '#2E7D32', timeout: 2500 })
      await timeout(2500)
      this.closeModalDataCirurgia()
    } else {
      // @ts-ignore
      EventBus.$emit('setSnackbar', { show: true, text: response.message || `Ocorreu um problema com essa requisição ${String.fromCodePoint(0x1F615)}`, icon: 'warning', color: '#C62828' })
    }

    this.loadingSchedule = false
  }
}
